import { Skeleton } from '@sea-snag/ui';
import { createFileRoute } from '@tanstack/react-router';

import { IncomeOverview } from '../../components/income/income-overview';
import { useRequiredOrganization } from '../../hooks/use-required-organization';
import { useYear } from '../../hooks/use-year';

export const Route = createFileRoute('/$orgPid/analytics/income')({
  component: AnalyticsIncomeTab,
});

function AnalyticsIncomeTab() {
  const { organization, isLoading } = useRequiredOrganization();
  const { boatPid } = Route.useSearch();
  const year = useYear();
  const orgPid = organization?.pid ?? '';

  if (isLoading || !orgPid) return <Skeleton className="h-[600px] w-full" />;
  return <IncomeOverview orgPid={orgPid} year={year} boatPid={boatPid} />;
}
